import Vue from 'vue'
import Router from 'vue-router'
import Tips from '@/components/Tips'
import AmongUs from '@/components/AmongUsShare'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [
  {
    path: '/',
    name: 'Tips',
    component: Tips,
    meta: {
      title: 'BOBO'
    }
  }, 
  // {
  //   path: '/',
  //   name: 'AmongUsShare',
  //   component: AmongUs,
  //   meta: {
  //     title: 'BOBO'
  //   }
  // },
  // {
  //   path: '/myCode',
  //   name: 'MyCode',
  //   component: MyCode
  // },
  // {
  //   path: '/writeCode',
  //   name: 'WriteCode',
  //   component: WriteCode,
  //   meta: {
  //     title: '地址填写'
  //   }
  // },
  // {
  //   path: '/writeAddress',
  //   name: 'WriteAddress',
  //   component: WriteAddress,
  //   meta: {
  //     title: '地址填写'
  //   }
  // },
  // {
  //   path: '/success',
  //   name: 'Success',
  //   component: Success,
  //   meta: {
  //     title: '地址填写'
  //   }
  // },
  // {
  //   path: '/had',
  //   name: 'HaveHad',
  //   component: HaveHad,
  //   meta: {
  //     title: '地址填写'
  //   }
  // },
  {
    path: '*',
    redirect: '/'
  }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js